export default {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
  callbackUrl: process.env.REACT_APP_AUTH0_REDIRECT_URI || '',
  apiUrl: process.env.REACT_APP_API_URL || ''
}


// WEBPACK FOOTER //
// ./src/config/variables.js